import React from 'react'
import styles from './overview.module.css'

export default () => (
  <div
    style={{
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <ul
      style={{
        display: 'flexbox',
        listStyle: 'none',
        margin: 0,
        padding: 0,
      }}
    >
      <li className={styles.listItem}>consulting</li>
      <li className={styles.listItem}>development</li>
      <li className={styles.listItem}>design</li>
      <li className={styles.listItem}>hosting</li>
    </ul>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/overview/overview.js